module.exports = __webpack_public_path__ + "img/image21@2x.f104f200.png";